export default class dealerFind {

  constructor(el) {
    this.el = el

    this.input = this.el.querySelector('.js-dealer-find-input');
    this.submitBtn = this.el.querySelector('.js-dealer-find-btn');
    this.errorMsg = this.el.querySelector('.js-dealer-find-error');
    this.dealerPageUrl = this.el.dataset.dealerPageUrl;

    if (!this.input || !this.submitBtn) return;
    this.init();
    
  }

  redirectPage() {
    if (!this.input.value.replace(/\s/g, '').length) {
      this.showValidationError();
      return
    }

    if(this.input.classList.contains('error')) {
      this.resetValidationError();
    }

    const val = this.input.value;
    const url = window.location.href;
    const arr = url.split("/");
    const result = arr[0] + "//" + arr[2];

    if (val !== '') {
        window.location.href = `${result}${this.dealerPageUrl}?location=${val}`;
      return;
    }
      window.location.href = `${result}${this.dealerPageUrl}`;
  }

  init() {

    this.submitBtn.addEventListener('click', () => this.redirectPage());

    this.input.addEventListener('keyup', e => {
      if (e.key === "Enter") this.redirectPage();
    })

  }

  showValidationError() {
    this.errorMsg.classList.add('show')
    this.input.classList.add('error')
  }

  resetValidationError() {
    this.errorMsg.classList.remove('show')
    this.input.classList.remove('error')
  }

}
